export type InfoPageLang = 'cs' | 'sk' | 'en' | 'hu' | 'uk' | 'ru';

export interface InfoPageConfig {
  name: string;
  i18nNamespace: string;
  metaNamespace: string;
  paths: Partial<Record<InfoPageLang, string>>;
  perexAsHtml?: boolean;
  availableInUaRu?: boolean;
  hideHeaderOnMobile?: boolean;
  thematicCounsellingPath?: string;
}

// New info pages: use a single English URL across all locales — do not translate
// the path per locale. The two entries below keep their localized paths only
// for backwards compatibility (existing SEO and external links).
export const infoPageRegistry: InfoPageConfig[] = [
  {
    name: 'emergency',
    i18nNamespace: 'emergency',
    metaNamespace: 'emergency',
    paths: {
      cs: '/kdy-na-pohotovost',
      sk: '/kedy-na-pohotovost',
      en: '/emergency',
      hu: '/emergency',
      uk: '/emergency',
      ru: '/emergency'
    },
    perexAsHtml: true,
    availableInUaRu: true,
    hideHeaderOnMobile: true,
    thematicCounsellingPath: 'kdy-na-pohotovost'
  },
  {
    name: 'ePrescription',
    i18nNamespace: 'ePrescription',
    metaNamespace: 'ePrescription',
    paths: {
      cs: '/e-recept',
      sk: '/e-recept',
      en: '/e-prescription',
      hu: '/e-prescription'
    },
    perexAsHtml: false
  }
];
